import React from 'react';
import { Text, Icon } from '../';
import { hideAlert as hideAlertAction } from '../../../redux/modules/alert';
import AlertBorder from './AlertBorder';
import AlertContainer, { AlertContainerWrapper } from './AlertContainer';
import { statusColor } from '../../../utils';
import AlertIcon from './AlertIcon';
import { useDispatch, useSelector } from '../../../hooks';

type Props = {
  alert?: Object,
  hideAlert?: Function,
  textSize?: String,
};

const spacing = 25;
const Alert = (props: Props) => {
  const { useStatic, className, textSize = 'md' } = props;
  const { position, message, isOpen, status } = useSelector('alert') || {};
  const dispatch = useDispatch();

  const hideAlert = () => dispatch(hideAlertAction());

  const handleTextColor = (status) =>
    status === 'warning' ? 'black' : statusColor(status);

  return isOpen ? (
    <AlertContainerWrapper position={position} spacing={spacing}>
      <AlertContainer
        position={position}
        spacing={spacing}
        className={className}
        useStatic={useStatic}
        status={status}
      >
        <AlertIcon status={status} />
        <Text
          color={handleTextColor(status)}
          size={textSize}
          className="py-2 px-5 mx-3 w-100"
        >
          {typeof message === 'string' ? message : JSON.stringify(message)}
        </Text>
        <Icon
          name="e-remove"
          size={30}
          onClick={hideAlert}
          color={handleTextColor(status)}
          className="px-1 pointer"
        />
        <AlertBorder direction={'rtl'} status={status} />
      </AlertContainer>
    </AlertContainerWrapper>
  ) : null;
};

export { Alert };
